import React from 'react';

import ProductCorePropertiesList from './list';
import ProductCorePropertiesTable from './table';
import {
  ProductCorePropertiesListProps,
  ProductCorePropertiesTableProps,
} from './types';

type ProductCorePropertiesProps =
  | ({ view: 'list' } & ProductCorePropertiesListProps)
  | ({ view: 'table' } & ProductCorePropertiesTableProps);

const ProductCoreProperties = (props: ProductCorePropertiesProps) =>
  props.view === 'table' ? (
    <ProductCorePropertiesTable {...props} />
  ) : (
    <ProductCorePropertiesList showAsList={props.showAsList} {...props} />
  );

ProductCoreProperties.defaultProps = {
  properties: undefined,
  toneDown: false,
  maxrows: undefined,
  size: 'large',
  showAsList: undefined,
  view: 'list',
  className: undefined,
  truncate: false,
};

export default ProductCoreProperties;
